import React from "react";
import { connect } from "react-redux";

import Header from "./_Header";
import OfflineMessage from "./_OfflineMessage";
import OfflineEmail from "./_OfflineEmail";
import AutoOption from "./_AutoOption";
import OnOption from "./_OnOption";
import OffOption from "./_OffOption";
import SchedulingOption from "./_SchedulingOption";
import OfflineFormular from "./_OfflineFormular";

import { Flex } from "/app/src/component";
import CustomizationModel from "/app/src/model/Customization/model";
import Jibber from "/app/src/jibber";

const ClientOfflineSettingsStyle = {
  dataName: "ClientOfflineSettings",
  width: "100%",
  hAlignContent: "center",
  column: true,
};
const OfflineSettingsBodyStyle = {
  dataName: "OfflineSettingsBodyStyle",
  width: "100%",
  column: true,
  overflowY: "auto",
  padding: "0px 15px 40px 15px",
  hAlignContent: "center",
};

const SeperatorStyle = {
  width: "90%",
  color: "lightgrey",
  border: "1px solid",
};

class FormularMainPanel extends Jibber {
  constructor(props) {
    super(props);
    this.useState({
      offlineConfig: props.customization["offline_formular_config"],
      offlineOn: props.customization["offline_formular_on"],
      offlineSmartOn: props.customization["offline_smart_formular_on"],
      offlineConditionOn: props.customization["offline_formular_condition_on"],
      offlineSmartConditionOn:
        props.customization["offline_smart_formular_condition_on"],
      offlineConditions: props.customization["offline_conditions"],
      offlineMessage: props.customization.offline_message,
      radioIndex: this.computeIndex(
        props.customization["offline_formular_on"],
        props.customization["offline_formular_condition_on"],
        props.customization["offline_smart_formular_on"]
      ),
      offlineEmail: props.customization["offline_email"],
      offlineEmailOn: props.customization["offline_email_on"],
    });

    this.selectOption = this.selectOption.bind(this);
    this.computeIndex = this.computeIndex.bind(this);
  }

  selectOption(option) {
    return () => {
      this.setRadioIndex(option);
      switch (option) {
        case "0":
          this.setOfflineOn(false);
          this.setOfflineConditionOn(false);
          this.setOfflineSmartOn(false);
          break;
        case "1":
          this.setOfflineOn(true);
          this.setOfflineConditionOn(false);
          this.setOfflineSmartOn(false);
          break;
        case "2":
          this.setOfflineOn(false);
          this.setOfflineConditionOn(true);
          this.setOfflineSmartOn(false);
          break;
        case "3":
          this.setOfflineOn(false);
          this.setOfflineConditionOn(false);
          this.setOfflineSmartOn(true);
          break;
        default:
          this.setOfflineOn(false);
          this.setOfflineConditionOn(false);
          this.setOfflineSmartOn(false);
          break;
      }
    };
  }

  /*
        Find the correct index from backend
    */
  computeIndex(offlineOn, offlineConditionOn, offlineSmartOn) {
    //  0 0 0
    if (!offlineOn && !offlineConditionOn && !offlineSmartOn) return "0";
    //  1 0 0
    if (offlineOn && !offlineConditionOn && !offlineSmartOn) return "1";
    //  0 1 0
    if (!offlineOn && offlineConditionOn && !offlineSmartOn) return "2";
    //  0 0 1
    if (!offlineOn && !offlineConditionOn && offlineSmartOn) return "3";
    return "0";
  }

  render() {
    if (!this.state.offlineConditions) return null;
    const saveOfflineSettings = () => {
      this.props.updateOfflineFormular({
        offline_message: this.state.offlineMessage,
        offline_formular_on: this.state.offlineOn,
        offline_smart_formular_on: this.state.offlineSmartOn,
        offline_formular_config: this.state.offlineConfig,
        offline_formular_condition_on: this.state.offlineConditionOn,
        offline_smart_formular_condition_on: this.state.offlineSmartConditionOn,
        offline_conditions: this.state.offlineConditions[0]["message"],
        offline_condition_id: this.state.offlineConditions[0]["id"],
        offline_email: this.state.offlineEmail,
        offline_email_on: this.state.offlineEmailOn,
      });
    };
    const currentSelected = this.state.radioIndex;
    return (
      <Flex {...ClientOfflineSettingsStyle}>
        <Header changed={this.state.changed} onClick={saveOfflineSettings} />

        <Flex {...OfflineSettingsBodyStyle}>
          <OfflineMessage
            offlineMessage={this.state.offlineMessage}
            setOfflineMessage={this.setOfflineMessage}
          />
          <Flex {...SeperatorStyle} marginTop="70px" />
          <OfflineFormular
            offlineConfig={this.state.offlineConfig}
            setOfflineConfig={this.setOfflineConfig}
          />
          <OfflineEmail
            offlineEmail={this.state.offlineEmail}
            setOfflineEmail={this.setOfflineEmail}
            offlineEmailOn={this.state.offlineEmailOn}
            setOfflineEmailOn={this.setOfflineEmailOn}
          ></OfflineEmail>
          <Flex {...SeperatorStyle} marginTop="30px" />
          <OffOption
            index="0"
            current={currentSelected}
            onSelected={this.selectOption}
          />
          <OnOption
            index="1"
            current={currentSelected}
            onSelected={this.selectOption}
          />
          <AutoOption
            index="3"
            current={currentSelected}
            onSelected={this.selectOption}
          />
          <SchedulingOption
            index="2"
            current={currentSelected}
            onSelected={this.selectOption}
            offlineConditions={this.state.offlineConditions}
            setOfflineConditions={this.setOfflineConditions}
            offlineSmartConditionOn={this.state.offlineSmartConditionOn}
            setOfflineSmartConditionOn={this.setOfflineSmartConditionOn}
          />
        </Flex>
      </Flex>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.customization !== this.props.customization) {
      this.setState({
        offlineOn: this.props.customization["offline_formular_on"],
        offlineConfig: this.props.customization["offline_formular_config"],
        offlineConditionOn: this.props.customization[
          "offline_formular_condition_on"
        ],
        offlineConditions: this.props.customization["offline_conditions"],
        offlineSmartConditionOn: this.props.customization[
          "offline_smart_formular_condition_on"
        ],
        offlineSmartOn: this.props.customization["offline_smart_formular_on"],
        radioIndex: this.computeIndex(
          this.props.customization["offline_formular_on"],
          this.props.customization["offline_formular_condition_on"],
          this.props.customization["offline_smart_formular_on"]
        ),
        changed: false,
      });
    }
  }
}

const {
  selector: updatesSelector,
  dispatcher: updatesRequest,
} = CustomizationModel.updates();

const mapDispatchToProps = (dispatch, props) => ({
  updateOfflineFormular: (updates) => dispatch(updatesRequest(updates)),
});

const mapStateToProps = (state, props) => ({
  customization: updatesSelector.customization(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormularMainPanel);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/index.js